import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { notificar } from '../utils/notify';
import '../styles/Das.css';
import '../styles/fmp.css';

const Apagar_cliente = () => {
  const { cliente_id } = useParams(); //  Pega ID da URL
  const navigate = useNavigate();
  
  const [todosOsDados, setTodosOsDados] = useState([]);
  const [dadosExibidos, setDadosExibidos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState('');

  useEffect(() => { notificar(mensagem); }, [mensagem]);

  const [paginaAtual, setPaginaAtual] = useState(1);
  const registrosPorPagina = 500;
  
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [dadosCarregados, setDadosCarregados] = useState(false);
  
  const [filtros, setFiltros] = useState({
    codigo_lancamento_omie: '',
    conta_corrente_descricao: '',
    categoria_descricao: '',
    status_titulo: '',
    valor_documento: '',
    cliente_nome_fantasia: ''
  });

  const [sistemaCliente, setSistemaCliente] = useState(null);

  // Descobre se o cliente é Omie ou Conta Azul para saber pra qual dashboard voltar
  useEffect(() => {
    if (!cliente_id) return;
    const token = localStorage.getItem('access');
    axios.get(
      `${process.env.REACT_APP_API_BASE}/api/cliente-bpo/${cliente_id}/`,
      { headers: { 'Authorization': `Bearer ${token}` } }
    )
      .then((response) => {
        if (response.data.success) {
          setSistemaCliente(response.data.cliente?.sistema || 'omie');
        }
      })
      .catch(() => {});
  }, [cliente_id]);

  const irParaDashboard = () => {
    if (sistemaCliente === 'conta_azul') {
      navigate(`/dashboard-conta-azul/${cliente_id}`);
    } else {
      navigate(`/dashboard-cliente/${cliente_id}`);
    }
  };

  const formatarValor = (valor) => {
    if (!valor) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(parseFloat(valor));
  };

  const formatarData = (data) => {
    if (!data) return '-';
    if (/^\d{4}-\d{2}-\d{2}/.test(data)) {
      const [ano, mes, dia] = data.slice(0, 10).split('-');
      return `${dia}/${mes}/${ano}`;
    }
    return data;
  };

  const converterDataParaComparacao = (data) => {
    if (!data) return null;
    const partes = data.split('/');
    if (partes.length === 3) {
      return `${partes[2]}-${partes[1].padStart(2, '0')}-${partes[0].padStart(2, '0')}`;
    }
    return null;
  };

  const ordenarPorVencimento = (dados) => {
    return dados.sort((a, b) => {
      const dataA = converterDataParaComparacao(a.data_vencimento);
      const dataB = converterDataParaComparacao(b.data_vencimento);
      
      if (!dataA && !dataB) return 0;
      if (!dataA) return 1;
      if (!dataB) return -1;
      
      return dataA.localeCompare(dataB);
    });
  };

  // status "em aberto" nos DOIS sistemas: Omie usa 'A VENCER'; Conta Azul usa 'EM_ABERTO'
  const STATUS_ABERTOS = ['a vencer', 'pendente', 'aberto', 'em_aberto', 'em aberto'];

  // Data que MANDA no atraso: a Omie envelhece o título pela PREVISÃO, não pelo
  // vencimento. Em parcelamento/renegociação ela deixa o vencimento na data
  // original (ex.: doc 91212 da Deskbee, 76 parcelas todas com venc 20/03/2025)
  // e coloca o cronograma real na previsão. Usar o vencimento marcava como
  // VENCIDO título que a própria Omie classifica como A VENCER.
  const dataDeAtraso = (conta) => conta?.data_previsao || conta?.data_vencimento;

  const normalizarStatus = (status, dataAtraso) => {
    const statusLower = (status || '').toLowerCase();
    if (STATUS_ABERTOS.includes(statusLower)) {
      // aceita DD/MM/YYYY e YYYY-MM-DD
      const dataConvertida = converterDataParaComparacao(dataAtraso) || dataAtraso;
      const hoje = new Date().toISOString().slice(0, 10);
      if (dataConvertida && dataConvertida < hoje) {
        return 'VENCIDO';
      }
    }
    return status;
  };

  const getStatusClass = (status) => {
    const s = (status || '').toLowerCase();
    if (['pago', 'liquidado'].includes(s)) return 'badge bg-success';
    if (STATUS_ABERTOS.includes(s)) return 'badge bg-warning text-dark';
    if (['vencido', 'atrasado'].includes(s)) return 'badge bg-danger';
    return 'badge bg-secondary';
  };

  const carregarDados = async () => {
    if (!dataInicio || !dataFim) {
      setMensagem('Por favor, informe o período de consulta (Data Início e Data Fim)');
      return;
    }

    setCarregando(true);
    setMensagem('Consultando banco de dados...');

    const accessToken = localStorage.getItem('access');
    
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/listar-contas-pagar-cliente/`,
        {
          params: {
            cliente_id: cliente_id, //  Envia cliente_id
            data_inicio: dataInicio,
            data_fim: dataFim
          },
          headers: { 
            'Authorization': `Bearer ${accessToken}` 
          },
          timeout: 0
        }
      );

      console.log('Resposta completa:', response.data);

      if (response.data.success) {
        const dados = response.data.dados;
        
        if (!dados.contas || !Array.isArray(dados.contas)) {
          throw new Error('Formato de dados inválido: contas não encontradas');
        }

        console.log('Total de contas:', dados.contas.length);
        
        const dadosOrdenados = ordenarPorVencimento([...dados.contas]);
        setTodosOsDados(dadosOrdenados);
        setDadosCarregados(true);
        setMensagem(` ${dadosOrdenados.length} registros carregados do banco de dados.`);
      } else {
        throw new Error(response.data.erro || 'Erro desconhecido');
      }
      
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      
      const errorMsg = error.response?.data?.erro || 
                       error.message || 
                       'Erro desconhecido ao carregar dados';
      setMensagem(`Erro: ${errorMsg}`);
      setTodosOsDados([]);
      setDadosCarregados(false);
    } finally {
      setCarregando(false);
    }
  };

  // cada grupo cobre as nomenclaturas dos DOIS sistemas — atenção: o Conta Azul
  // marca conta a pagar quitada como 'RECEBIDO' (tradução da API deles)
  const statusGrupos = {
    pago:     ['pago', 'liquidado', 'recebido', 'baixado'],
    pendente: ['pendente', 'a vencer', 'aberto'],
    vencido:  ['vencido', 'atrasado'],
  };

  const matchStatus = (statusConta, dataAtraso, filtroStatus) => {
    if (!filtroStatus) return true;
    const statusNormalizado = normalizarStatus(statusConta, dataAtraso);
    const statusLower = (statusNormalizado || '').toLowerCase();
    // "Vencidas e a Pagar" = tudo que não está pago (pendente/a vencer + vencido/atrasado)
    if (filtroStatus === 'vencidas_a_pagar') {
      return [...statusGrupos.pendente, ...statusGrupos.vencido].some(s => statusLower.includes(s));
    }
    const grupo = statusGrupos[filtroStatus];
    return grupo ? grupo.some(s => statusLower.includes(s)) : statusLower.includes(filtroStatus);
  };

  const aplicarFiltrosEPaginacao = () => {
    const dadosFiltrados = todosOsDados.filter(conta => {
      const filtrosTexto = [
        'codigo_lancamento_omie',
        'conta_corrente_descricao',
        'valor_documento',
        'cliente_nome_fantasia'
      ];
      const textoOk = filtrosTexto.every(campo => {
        const valorFiltro = filtros[campo];
        if (!valorFiltro) return true;
        const valorConta = conta[campo]?.toString().toLowerCase() || '';
        return valorConta.includes(valorFiltro.toLowerCase());
      });
      const cat = (conta.categoria_descricao || conta.nome_categoria || '');
      const categoriaOk = !filtros.categoria_descricao || cat === filtros.categoria_descricao;
      return textoOk && categoriaOk && matchStatus(conta.status_titulo, dataDeAtraso(conta), filtros.status_titulo);
    });

    const dadosFiltradosOrdenados = ordenarPorVencimento([...dadosFiltrados]);

    const inicio = (paginaAtual - 1) * registrosPorPagina;
    const fim = inicio + registrosPorPagina;
    const dadosPaginados = dadosFiltradosOrdenados.slice(inicio, fim);

    setDadosExibidos(dadosPaginados);
  };

  useEffect(() => {
    if (dadosCarregados) {
      aplicarFiltrosEPaginacao();
    }
  }, [todosOsDados, filtros, paginaAtual, dadosCarregados]);

  const limparFiltros = () => {
    setFiltros({
      codigo_lancamento_omie: '',
      conta_corrente_descricao: '',
      categoria_descricao: '',
      status_titulo: '',
      valor_documento: '',
      cliente_nome_fantasia: ''
    });
    setPaginaAtual(1);
  };

  const limparTudo = () => {
    setDataInicio('');
    setDataFim('');
    setTodosOsDados([]);
    setDadosExibidos([]);
    setDadosCarregados(false);
    setMensagem('');
    limparFiltros();
  };

  const dadosFiltrados = todosOsDados.filter(conta => {
    const filtrosTexto = [
      'codigo_lancamento_omie',
      'conta_corrente_descricao',
      'valor_documento',
      'cliente_nome_fantasia'
    ];
    const textoOk = filtrosTexto.every(campo => {
      const valorFiltro = filtros[campo];
      if (!valorFiltro) return true;
      const valorConta = conta[campo]?.toString().toLowerCase() || '';
      return valorConta.includes(valorFiltro.toLowerCase());
    });
    const cat = (conta.categoria_descricao || conta.nome_categoria || '');
    const categoriaOk = !filtros.categoria_descricao || cat === filtros.categoria_descricao;
    // faltava a data aqui: `filtros.status_titulo` caía no parâmetro da data e o
    // filtroStatus chegava undefined, então o total somava TUDO do período
    return textoOk && categoriaOk && matchStatus(conta.status_titulo, dataDeAtraso(conta), filtros.status_titulo);
  });

  // Lista única de categorias (para o select de filtro)
  const categoriasDisponiveis = [...new Set(
    todosOsDados.map(c => (c.categoria_descricao || c.nome_categoria || '').trim()).filter(Boolean)
  )].sort((a, b) => a.localeCompare(b));

  // Soma do valor dos registros filtrados (todo o resultado, não só a página)
  const totalFiltrado = dadosFiltrados.reduce((s, c) => s + (parseFloat(c.valor_documento) || 0), 0);

  const totalPaginasCalculadas = Math.ceil(dadosFiltrados.length / registrosPorPagina);

  const mudarPagina = (novaPagina) => {
    if (novaPagina >= 1 && novaPagina <= totalPaginasCalculadas) {
      setPaginaAtual(novaPagina);
    }
  };

  useEffect(() => {
    setPaginaAtual(1);
  }, [filtros]);

  return (
    <div className="das-page fmp-brand-page">
      <div className="container mt-5 shadow p-4 rounded bg-white">
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center">
            <i className="fas fa-money-bill-wave header-icon me-2"></i>
            <h2 className="titulo-pagina m-0">Contas a Pagar </h2>
          </div>
          <button
            className="btn btn-outline-primary"
            onClick={irParaDashboard}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Voltar ao Dashboard
          </button>
        </div>

        <div className="card mb-3" style={{ borderColor: "#00205b" }}>
          <div className="card-header bg-white">
            <h6 className="mb-0">
              <i className="fas fa-calendar-check me-2"></i>
              Consultar Período
            </h6>
          </div>

          <div className="card-body">
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label fw-bold">Data Início: *</label>
                <input
                  type="date"
                  className="form-control"
                  value={dataInicio}
                  onChange={(e) => setDataInicio(e.target.value)}
                  disabled={carregando}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-bold">Data Fim: *</label>
                <input
                  type="date"
                  className="form-control"
                  value={dataFim}
                  onChange={(e) => setDataFim(e.target.value)}
                  disabled={carregando}
                />
              </div>
              <div className="col-md-6">
                <div className="d-flex gap-2">
                  <button 
                    className="btn btn-primary"
                    onClick={carregarDados}
                    disabled={carregando || !dataInicio || !dataFim}
                  >
                    <i className={`fas ${carregando ? 'fa-spinner fa-spin' : 'fa-search'} me-2`}></i>
                    {carregando ? 'Consultando...' : 'Consultar'}
                  </button>
                  <button 
                    className="btn btn-outline-secondary"
                    onClick={limparTudo}
                    disabled={carregando}
                  >
                    <i className="fas fa-times me-2"></i>
                    Limpar Tudo
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-2">
              <small className="text-muted">
                <i className="fas fa-info-circle me-1"></i>
                Os dados são sincronizados por processo externo (Cloud Run Jobs).
              </small>
            </div>
          </div>
        </div>

        {/* Mensagens agora são exibidas como toast (react-toastify) */}

        {dadosCarregados && (
          <>
            <div className="alert alert-light border-start border-primary border-4 mb-3">
              <small className="text-muted">
                <i className="fas fa-sort-amount-down me-2"></i>
                <strong>Ordenação:</strong> Dados ordenados por <strong>data de vencimento</strong> (do mais antigo para o mais recente)
              </small>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center gap-2">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={limparFiltros}
                  title="Limpar filtros da tabela"
                >
                  <i className="fas fa-eraser me-2"></i>
                  Limpar Filtros
                </button>
                <span className="badge d-inline-flex align-items-center" style={{ backgroundColor: '#00205b', color: '#fff', fontSize: '0.9rem', padding: '8px 14px' }}>
                  <i className="fas fa-coins me-2"></i>
                  Total filtrado: {formatarValor(totalFiltrado)}
                </span>
              </div>

              {totalPaginasCalculadas > 1 && (
                <nav>
                  <ul className="pagination pagination-sm mb-0">
                    <li className={`page-item ${paginaAtual === 1 ? 'disabled' : ''}`}>
                      <button 
                        className="page-link" 
                        onClick={() => mudarPagina(paginaAtual - 1)}
                        disabled={paginaAtual === 1}
                      >
                        Anterior
                      </button>
                    </li>
                    
                    <li className="page-item active">
                      <span className="page-link">
                        {paginaAtual} de {totalPaginasCalculadas}
                      </span>
                    </li>
                    
                    <li className={`page-item ${paginaAtual === totalPaginasCalculadas ? 'disabled' : ''}`}>
                      <button 
                        className="page-link" 
                        onClick={() => mudarPagina(paginaAtual + 1)}
                        disabled={paginaAtual === totalPaginasCalculadas}
                      >
                        Próximo
                      </button>
                    </li>
                  </ul>
                </nav>
              )}
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-hover text-center align-middle fs-6">
                <thead className="table-light">
                  <tr>
                    <th>
                      Categoria
                      <select
                        className="form-select form-select-sm mt-1"
                        value={filtros.categoria_descricao}
                        onChange={(e) => setFiltros(prev => ({
                          ...prev,
                          categoria_descricao: e.target.value
                        }))}
                      >
                        <option value="">Todas</option>
                        {categoriasDisponiveis.map((cat) => (
                          <option key={cat} value={cat}>{cat}</option>
                        ))}
                      </select>
                    </th>
                    <th>
                      Data Vencimento 
                      <i className="fas fa-sort-amount-down ms-1 text-primary" title="Ordenado crescente"></i>
                    </th>
                    <th>
                      Valor
                      <input
                        type="text"
                        className="form-control form-control-sm mt-1"
                        placeholder="Filtrar..."
                        value={filtros.valor_documento}
                        onChange={(e) => setFiltros(prev => ({ 
                          ...prev, 
                          valor_documento: e.target.value 
                        }))}
                      />
                    </th>
                    <th>
                      Status
                      <select
                        className="form-select form-select-sm mt-1"
                        value={filtros.status_titulo}
                        onChange={(e) => setFiltros(prev => ({
                          ...prev,
                          status_titulo: e.target.value
                        }))}
                      >
                        <option value="">Todos</option>
                        {/* opções seguem a nomenclatura do SISTEMA do cliente;
                            o filtro busca todos os status equivalentes por baixo */}
                        {sistemaCliente === 'conta_azul' ? (
                          <>
                            <option value="vencidas_a_pagar">Não Pago</option>
                            <option value="pago">Pago</option>
                            <option value="pendente">Em Aberto</option>
                            <option value="vencido">Atrasado</option>
                          </>
                        ) : (
                          <>
                            <option value="vencidas_a_pagar">Não Pago</option>
                            <option value="pago">Pago</option>
                            <option value="pendente">A Vencer</option>
                            <option value="vencido">Atrasado</option>
                          </>
                        )}
                      </select>
                    </th>
                    <th>
                      Cliente/Fornecedor
                      <input
                        type="text"
                        className="form-control form-control-sm mt-1"
                        placeholder="Filtrar..."
                        value={filtros.cliente_nome_fantasia}
                        onChange={(e) => setFiltros(prev => ({ 
                          ...prev, 
                          cliente_nome_fantasia: e.target.value 
                        }))}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dadosExibidos.map((conta, index) => (
                    <tr key={conta.codigo_lancamento_omie || index}>
                      <td className="text-start">
                        {conta.categoria_descricao || conta.nome_categoria || '-'}
                      </td>
                      <td>
                        {formatarData(conta.data_vencimento)}
                        {/* previsão diferente do vencimento: é ela que define o atraso */}
                        {conta.data_previsao && conta.data_previsao !== conta.data_vencimento && (
                          <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                            prev. {formatarData(conta.data_previsao)}
                          </div>
                        )}
                      </td>
                      <td className="text-end">
                        {formatarValor(conta.valor_documento)}
                      </td>
                      <td>
                        {(() => {
                          const statusFinal = normalizarStatus(conta.status_titulo, dataDeAtraso(conta));
                          return (
                            <span className={getStatusClass(statusFinal)}>
                              {statusFinal}
                            </span>
                          );
                        })()}
                      </td>
                      <td className="text-start">
                        {conta.cliente_nome_fantasia || conta.nome_fornecedor || '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              
              {dadosExibidos.length === 0 && (
                <div className="text-center mt-4">
                  <p className="text-muted">Nenhuma conta encontrada com os filtros aplicados.</p>
                </div>
              )}
            </div>

            {todosOsDados.length > 0 && (
              <div className="mt-3 text-muted small">
                Exibindo {dadosExibidos.length} de {dadosFiltrados.length} registros filtrados
                (Total carregado: {todosOsDados.length} registros)
              </div>
            )}
          </>
        )}

        {!dadosCarregados && !carregando && (
          <div className="text-center mt-5 mb-5">
            <i className="fas fa-database fa-3x text-muted mb-3"></i>
            <h5 className="text-muted">Selecione um período para consultar as contas a pagar</h5>
            <p className="text-muted small">
              A sincronização com a API {sistemaCliente === 'conta_azul' ? 'Conta Azul' : 'Omie'} é feita por processo externo automatizado.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Apagar_cliente;